export const SmallScreenWidthBreakpoint: number = 1200;
